import { missingNativeBuild } from "../nativeError";
var Contacts = Object.freeze({
  getPermissionStatus: function getPermissionStatus() {
    return "denied";
  },
  requestPermission: function requestPermission() {
    return Promise.resolve("denied");
  },
  pickContact: function pickContact() {
    return Promise.reject(missingNativeBuild("Contacts.pickContact"));
  },
  search: function search(_name) {
    var _limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return Promise.resolve([]);
  },
  create: function create(_input) {
    return Promise.reject(missingNativeBuild("Contacts.create"));
  },
  update: function update(_identifier, _changes) {
    return Promise.reject(missingNativeBuild("Contacts.update"));
  },
  delete: function _delete(_identifier) {
    return Promise.resolve();
  }
});
export {
  Contacts
};
//# sourceMappingURL=unavailable.js.map
